import { useCallback, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteCatalogItem, selectCatalogId } from "../../../redux/catalog";

export interface CatalogBulkDeleteItem {
    item_id: string;
    [key: string]: unknown;
}

interface BulkDeletePopupState {
    items: CatalogBulkDeleteItem[];
}

export function useBulkDeletePopup() {
    const dispatch = useDispatch();
    const catalogId = useSelector(selectCatalogId);
    const [popupState, setPopupState] = useState<BulkDeletePopupState | null>(null);
    const [deleteInput, setDeleteInput] = useState("");
    const [deleting, setDeleting] = useState(false);
    const setExecutingRef = useRef<(executing: boolean) => void>(() => {});

    const openDeletePopup = useCallback(
        (items: CatalogBulkDeleteItem[], setExecuting: (executing: boolean) => void) => {
            setExecutingRef.current = setExecuting;
            setDeleteInput("");
            setPopupState({ items });
        },
        [],
    );

    const closeDeletePopup = useCallback(() => {
        setPopupState(null);
        setDeleteInput("");
    }, []);

    const onConfirm = useCallback(async () => {
        if (!catalogId || !popupState || popupState.items.length === 0) return;
        setDeleting(true);
        setExecutingRef.current(true);
        try {
            await Promise.all(
                popupState.items.map((item) =>
                    dispatch(
                        deleteCatalogItem({ catalogId, itemId: item.item_id }) as any,
                    ),
                ),
            );
        } finally {
            setDeleting(false);
            setExecutingRef.current(false);
            closeDeletePopup();
        }
    }, [catalogId, dispatch, popupState, closeDeletePopup]);

    return {
        popupState,
        deleteInput,
        deleting,
        openDeletePopup,
        onDeleteInputChange: setDeleteInput,
        onCancel: closeDeletePopup,
        onConfirm,
    };
}
